export default "__VITE_ASSET__6f10be2e__"